import { render, staticRenderFns } from "./tags-nav.vue?vue&type=template&id=132069c0"
import script from "./tags-nav.vue?vue&type=script&lang=ts"
export * from "./tags-nav.vue?vue&type=script&lang=ts"
import style0 from "./tags-nav.vue?vue&type=style&index=0&id=132069c0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports